module.exports = __webpack_public_path__ + "img/United Kingdom.9f129aa6.svg";